module.exports = __webpack_public_path__ + "static/media/permission-success.663d5001.svg";